import Dialog from "./Dialog";
import DialogTitle from "./DialogTitle";
import DialogContent from "./DialogContent";
import DialogScrollArea from "./DialogScrollArea";
import DialogActions from "./DialogActions";

export {
    Dialog as default,
    DialogTitle,
    DialogContent,
    DialogScrollArea,
    DialogActions,
};